import {
    Box, Card, CardActionArea, CardContent, 
    Paper, TableCell,  TableRow, Typography,
    tableCellClasses,
    Checkbox as MuiCheckBox,
    FormControl, FormControlLabel,
    Select,
    MenuItem,
    InputLabel,
    IconButton,
    Tooltip,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { useEffect, useMemo, useState } from "react";
import { FerramentasDeDetalhe } from "../../shered/components";
import { LayoutBaseDePagina } from "../../shered/layouts/LayoutBaseDePagina";
import { IDadosLigaCard, IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../shered/contexts";
import { styled } from '@mui/material/styles';
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { enumMargemAposta, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { ApostaService, IDadosJogosNbaApostas, IDetalheAposta, IFiltroJogos } from "../../shered/services/api/apostas/ApostasService";
import { Loading } from "../../shered/components/loading/Loading";
import { VForm, useVForm } from "../../shered/forms";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import { Cancel } from "@mui/icons-material";

export const ListagemDeJogos = () => {
    const { isAuthenticated, logout } = useAuthContext();
    const navigate = useNavigate();
    const user = CookieService.get("access_user");
    // const theme = useAppThemeContext();    

    const [listaApostasRows, setListaApostasRows] = useState<IDetalheAposta[]>([]);    
    const [isLoading, setIsLoading] = useState(true);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [searchParams, SetSearchParams] = useSearchParams();    
    const [redirecionar, setRedirecionar] = useState("0");
    const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();

    const [filtroCodigoJogo, setFiltroCodigoJogo] = useState(0);
    const [filtroMandante, setFiltroMandante] = useState(0);
    const [filtroVisitante, setFiltroVisitante] = useState(0);
    const [quantidadeDias, setQuantidadeDias] = useState(1);    
    const [semImagem, setSemImagem] = useState<any>("../../../semimagem.png");
    //#region 
    const [chkMandante1, setChkMandante1] = useState(false);
    const [chkVisitante1, setChkVisitante1] = useState(false);
    const [margemEscolha1, setMargemEscolha1] = useState(1);
    const [chkMandante2, setChkMandante2] = useState(false);
    const [chkVisitante2, setChkVisitante2] = useState(false);
    const [margemEscolha2, setMargemEscolha2] = useState(1);
    const [chkMandante3, setChkMandante3] = useState(false);
    const [chkVisitante3, setChkVisitante3] = useState(false);
    const [margemEscolha3, setMargemEscolha3] = useState(1);
    const [chkMandante4, setChkMandante4] = useState(false);
    const [chkVisitante4, setChkVisitante4] = useState(false);
    const [margemEscolha4, setMargemEscolha4] = useState(1);
    const [chkMandante5, setChkMandante5] = useState(false);
    const [chkVisitante5, setChkVisitante5] = useState(false);
    const [margemEscolha5, setMargemEscolha5] = useState(1);
    const [chkMandante6, setChkMandante6] = useState(false);
    const [chkVisitante6, setChkVisitante6] = useState(false);
    const [margemEscolha6, setMargemEscolha6] = useState(1);
    const [chkMandante7, setChkMandante7] = useState(false);
    const [chkVisitante7, setChkVisitante7] = useState(false);
    const [margemEscolha7, setMargemEscolha7] = useState(1);
    const [chkMandante8, setChkMandante8] = useState(false);
    const [chkVisitante8, setChkVisitante8] = useState(false);
    const [margemEscolha8, setMargemEscolha8] = useState(1);
    const [chkMandante9, setChkMandante9] = useState(false);
    const [chkVisitante9, setChkVisitante9] = useState(false);
    const [margemEscolha9, setMargemEscolha9] = useState(false);
    const [chkMandante10, setChkMandante10] = useState(false);
    const [chkVisitante10, setChkVisitante10] = useState(false);
    const [margemEscolha10, setMargemEscolha10] = useState(1);
    const [chkMandante11, setChkMandante11] = useState(false);
    const [chkVisitante11, setChkVisitante11] = useState(false);
    const [margemEscolha11, setMargemEscolha11] = useState(1);
    const [chkMandante12, setChkMandante12] = useState(false);
    const [chkVisitante12, setChkVisitante12] = useState(false);
    const [margemEscolha12, setMargemEscolha12] = useState(1);
    const [chkMandante13, setChkMandante13] = useState(false);
    const [chkVisitante13, setChkVisitante13] = useState(false);
    const [margemEscolha13, setMargemEscolha13] = useState(1);
    const [chkMandante14, setChkMandante14] = useState(false);
    const [chkVisitante14, setChkVisitante14] = useState(false);
    const [margemEscolha14, setMargemEscolha14] = useState(1);
    const [chkMandante15, setChkMandante15] = useState(false);
    const [chkVisitante15, setChkVisitante15] = useState(false);
    const [margemEscolha15, setMargemEscolha15] = useState(1);
    const [chkMandante16, setChkMandante16] = useState(false);
    const [chkVisitante16, setChkVisitante16] = useState(false);
    const [margemEscolha16, setMargemEscolha16] = useState(1);
    const [chkMandante17, setChkMandante17] = useState(false);
    const [chkVisitante17, setChkVisitante17] = useState(false);
    const [margemEscolha17, setMargemEscolha17] = useState(1);
    const [chkMandante18, setChkMandante18] = useState(false);
    const [chkVisitante18, setChkVisitante18] = useState(false);
    const [margemEscolha18, setMargemEscolha18] = useState(1);
    const [chkMandante19, setChkMandante19] = useState(false);
    const [chkVisitante19, setChkVisitante19] = useState(false);
    const [margemEscolha19, setMargemEscolha19] = useState(1);
    const [chkMandante20, setChkMandante20] = useState(false);
    const [chkVisitante20, setChkVisitante20] = useState(false);
    const [margemEscolha20, setMargemEscolha20] = useState(1);
    const [chkMandante21, setChkMandante21] = useState(false);
    const [chkVisitante21, setChkVisitante21] = useState(false);
    const [margemEscolha21, setMargemEscolha21] = useState(1);
    const [chkMandante22, setChkMandante22] = useState(false);
    const [chkVisitante22, setChkVisitante22] = useState(false);
    const [margemEscolha22, setMargemEscolha22] = useState(1);
    const [chkMandante23, setChkMandante23] = useState(false);
    const [chkVisitante23, setChkVisitante23] = useState(false);
    const [margemEscolha23, setMargemEscolha23] = useState(1);
    const [chkMandante24, setChkMandante24] = useState(false);
    const [chkVisitante24, setChkVisitante24] = useState(false);
    const [margemEscolha24, setMargemEscolha24] = useState(1);
    const [chkMandante25, setChkMandante25] = useState(false);
    const [chkVisitante25, setChkVisitante25] = useState(false);
    const [margemEscolha25, setMargemEscolha25] = useState(1);
    const [chkMandante26, setChkMandante26] = useState(false);
    const [chkVisitante26, setChkVisitante26] = useState(false);
    const [margemEscolha26, setMargemEscolha26] = useState(1);
    const [chkMandante27, setChkMandante27] = useState(false);
    const [chkVisitante27, setChkVisitante27] = useState(false);
    const [margemEscolha27, setMargemEscolha27] = useState(1);
    const [chkMandante28, setChkMandante28] = useState(false);
    const [chkVisitante28, setChkVisitante28] = useState(false);
    const [margemEscolha28, setMargemEscolha28] = useState(1);
    const [chkMandante29, setChkMandante29] = useState(false);
    const [chkVisitante29, setChkVisitante29] = useState(false);
    const [margemEscolha29, setMargemEscolha29] = useState(1);
    const [chkMandante30, setChkMandante30] = useState(false);
    const [chkVisitante30, setChkVisitante30] = useState(false);
    const [margemEscolha30, setMargemEscolha30] = useState(1);
    const [chkMandante31, setChkMandante31] = useState(false);
    const [chkVisitante31, setChkVisitante31] = useState(false);
    const [margemEscolha31, setMargemEscolha31] = useState(1);
    const [chkMandante32, setChkMandante32] = useState(false);
    const [chkVisitante32, setChkVisitante32] = useState(false);
    const [margemEscolha32, setMargemEscolha32] = useState(1);
    const [chkMandante33, setChkMandante33] = useState(false);
    const [chkVisitante33, setChkVisitante33] = useState(false);
    const [margemEscolha33, setMargemEscolha33] = useState(1);
    const [chkMandante34, setChkMandante34] = useState(false);
    const [chkVisitante34, setChkVisitante34] = useState(false);
    const [margemEscolha34, setMargemEscolha34] = useState(1);
    const [chkMandante35, setChkMandante35] = useState(false);
    const [chkVisitante35, setChkVisitante35] = useState(false);
    const [margemEscolha35, setMargemEscolha35] = useState(1);
    const [chkMandante36, setChkMandante36] = useState(false);
    const [chkVisitante36, setChkVisitante36] = useState(false);
    const [margemEscolha36, setMargemEscolha36] = useState(1);
    const [chkMandante37, setChkMandante37] = useState(false);
    const [chkVisitante37, setChkVisitante37] = useState(false);
    const [margemEscolha37, setMargemEscolha37] = useState(1);
    const [chkMandante38, setChkMandante38] = useState(false);
    const [chkVisitante38, setChkVisitante38] = useState(false);
    const [margemEscolha38, setMargemEscolha38] = useState(1);
    const [chkMandante39, setChkMandante39] = useState(false);
    const [chkVisitante39, setChkVisitante39] = useState(false);
    const [margemEscolha39, setMargemEscolha39] = useState(1);
    const [chkMandante40, setChkMandante40] = useState(false);
    const [chkVisitante40, setChkVisitante40] = useState(false);
    const [margemEscolha40, setMargemEscolha40] = useState(1);
    const [chkMandante41, setChkMandante41] = useState(false);
    const [chkVisitante41, setChkVisitante41] = useState(false);
    const [margemEscolha41, setMargemEscolha41] = useState(1);
    const [chkMandante42, setChkMandante42] = useState(false);
    const [chkVisitante42, setChkVisitante42] = useState(false);
    const [margemEscolha42, setMargemEscolha42] = useState(1);
    const [chkMandante43, setChkMandante43] = useState(false);
    const [chkVisitante43, setChkVisitante43] = useState(false);
    const [margemEscolha43, setMargemEscolha43] = useState(1);
    const [chkMandante44, setChkMandante44] = useState(false);
    const [chkVisitante44, setChkVisitante44] = useState(false);
    const [margemEscolha44, setMargemEscolha44] = useState(1);
    const [chkMandante45, setChkMandante45] = useState(false);
    const [chkVisitante45, setChkVisitante45] = useState(false);
    const [margemEscolha45, setMargemEscolha45] = useState(1);
    const [chkMandante46, setChkMandante46] = useState(false);
    const [chkVisitante46, setChkVisitante46] = useState(false);
    const [margemEscolha46, setMargemEscolha46] = useState(1);
    const [chkMandante47, setChkMandante47] = useState(false);
    const [chkVisitante47, setChkVisitante47] = useState(false);
    const [margemEscolha47, setMargemEscolha47] = useState(1);
    const [chkMandante48, setChkMandante48] = useState(false);
    const [chkVisitante48, setChkVisitante48] = useState(false);
    const [margemEscolha48, setMargemEscolha48] = useState(1);
    const [chkMandante49, setChkMandante49] = useState(false);
    const [chkVisitante49, setChkVisitante49] = useState(false);
    const [margemEscolha49, setMargemEscolha49] = useState(1);
    const [chkMandante50, setChkMandante50] = useState(false);
    const [chkVisitante50, setChkVisitante50] = useState(false);
    const [margemEscolha50, setMargemEscolha50] = useState(1);
    const [chkMandante51, setChkMandante51] = useState(false);
    const [chkVisitante51, setChkVisitante51] = useState(false);
    const [margemEscolha51, setMargemEscolha51] = useState(1);
    const [chkMandante52, setChkMandante52] = useState(false);
    const [chkVisitante52, setChkVisitante52] = useState(false);
    const [margemEscolha52, setMargemEscolha52] = useState(1);
    const [chkMandante53, setChkMandante53] = useState(false);
    const [chkVisitante53, setChkVisitante53] = useState(false);
    const [margemEscolha53, setMargemEscolha53] = useState(1);
    const [chkMandante54, setChkMandante54] = useState(false);
    const [chkVisitante54, setChkVisitante54] = useState(false);
    const [margemEscolha54, setMargemEscolha54] = useState(1);
    const [chkMandante55, setChkMandante55] = useState(false);
    const [chkVisitante55, setChkVisitante55] = useState(false);
    const [margemEscolha55, setMargemEscolha55] = useState(1);
    const [chkMandante56, setChkMandante56] = useState(false);
    const [chkVisitante56, setChkVisitante56] = useState(false);
    const [margemEscolha56, setMargemEscolha56] = useState(1);
    const [chkMandante57, setChkMandante57] = useState(false);
    const [chkVisitante57, setChkVisitante57] = useState(false);
    const [margemEscolha57, setMargemEscolha57] = useState(1);
    const [chkMandante58, setChkMandante58] = useState(false);
    const [chkVisitante58, setChkVisitante58] = useState(false);
    const [margemEscolha58, setMargemEscolha58] = useState(1);
    const [chkMandante59, setChkMandante59] = useState(false);
    const [chkVisitante59, setChkVisitante59] = useState(false);
    const [margemEscolha59, setMargemEscolha59] = useState(1);
    const [chkMandante60, setChkMandante60] = useState(false);
    const [chkVisitante60, setChkVisitante60] = useState(false);
    const [margemEscolha60, setMargemEscolha60] = useState(1);

    const [pick1, setPick1] = useState(false);
    const [pick2, setPick2] = useState(false);
    const [pick3, setPick3] = useState(false);
    const [pick4, setPick4] = useState(false);
    const [pick5, setPick5] = useState(false);
    const [pick6, setPick6] = useState(false);
    const [pick7, setPick7] = useState(false);
    const [pick8, setPick8] = useState(false);
    const [pick9, setPick9] = useState(false);
    const [pick10, setPick10] = useState(false);
    const [pick11, setPick11] = useState(false);
    const [pick12, setPick12] = useState(false);
    const [pick13, setPick13] = useState(false);
    const [pick14, setPick14] = useState(false);
    const [pick15, setPick15] = useState(false);
    const [pick16, setPick16] = useState(false);
    const [pick17, setPick17] = useState(false);
    const [pick18, setPick18] = useState(false);
    const [pick19, setPick19] = useState(false);
    const [pick20, setPick20] = useState(false);
    const [pick21, setPick21] = useState(false);
    const [pick22, setPick22] = useState(false);
    const [pick23, setPick23] = useState(false);
    const [pick24, setPick24] = useState(false);
    const [pick25, setPick25] = useState(false);
    const [pick26, setPick26] = useState(false);
    const [pick27, setPick27] = useState(false);
    const [pick28, setPick28] = useState(false);
    const [pick29, setPick29] = useState(false);
    const [pick30, setPick30] = useState(false);
    const [pick31, setPick31] = useState(false);
    const [pick32, setPick32] = useState(false);
    const [pick33, setPick33] = useState(false);
    const [pick34, setPick34] = useState(false);
    const [pick35, setPick35] = useState(false);
    const [pick36, setPick36] = useState(false);
    const [pick37, setPick37] = useState(false);
    const [pick38, setPick38] = useState(false);
    const [pick39, setPick39] = useState(false);
    const [pick40, setPick40] = useState(false);
    const [pick41, setPick41] = useState(false);
    const [pick42, setPick42] = useState(false);
    const [pick43, setPick43] = useState(false);
    const [pick44, setPick44] = useState(false);
    const [pick45, setPick45] = useState(false);
    const [pick46, setPick46] = useState(false);
    const [pick47, setPick47] = useState(false);
    const [pick48, setPick48] = useState(false);
    const [pick49, setPick49] = useState(false);
    const [pick50, setPick50] = useState(false);
    const [pick51, setPick51] = useState(false);
    const [pick52, setPick52] = useState(false);
    const [pick53, setPick53] = useState(false);
    const [pick54, setPick54] = useState(false);
    const [pick55, setPick55] = useState(false);
    const [pick56, setPick56] = useState(false);
    const [pick57, setPick57] = useState(false);
    const [pick58, setPick58] = useState(false);
    const [pick59, setPick59] = useState(false);
    const [pick60, setPick60] = useState(false);
    const [pick61, setPick61] = useState(false);
    const [pick62, setPick62] = useState(false);
    const [pick63, setPick63] = useState(false);
    const [pick64, setPick64] = useState(false);
    const [pick65, setPick65] = useState(false);
    const [pick66, setPick66] = useState(false);
    const [pick67, setPick67] = useState(false);
    const [pick68, setPick68] = useState(false);
    const [pick69, setPick69] = useState(false);
    const [pick70, setPick70] = useState(false);
    const [pick71, setPick71] = useState(false);
    const [pick72, setPick72] = useState(false);
    const [pick73, setPick73] = useState(false);
    const [pick74, setPick74] = useState(false);
    const [pick75, setPick75] = useState(false);



    //#endregion

    const [lstJogosNba, setLstJogosNba] = useState<IDadosJogosNbaApostas[]>([]);
    const [lstDataJogosNba, setLstDataJogosNba] = useState<any[]>([]);
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja renovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });

    const busca = useMemo(() => {
        return searchParams.get("busca") || "";
    }, [searchParams]);

    useEffect(() => {
        localStorage.setItem("paginaVoltar", "");
        if (!isAuthenticated) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Sessão expirada!",
                display: "none",
                titulo: "Atenção"
            });
            logout();
            setRedirecionar("0");
            return;
        }

        const fetchData = async () => {
            setSemImagem(user.imagem_Perfil !== null ? user.imagem_Perfil : semImagem);
            handleCarregarJogosNBA(null, null, null, "", quantidadeDias);
        }
        fetchData();
    }, []);


    const handleCarregarJogosNBA = async (codigoJogo: number | null, mandante: number | null, visitante: number | null, filtroData: string, filtroQtdDias: number) => {
        setIsLoading(true);
        setRemoveLoading(false);
        let filtro: IFiltroJogos = {
            codigo: null,
            codigo_Usuario: user.codUsuario,
            codigo_Jogo: filtroCodigoJogo > 0 ? filtroCodigoJogo : codigoJogo,
            codigo_Franquia_Mandante: filtroMandante > 0 ? filtroMandante : mandante,
            codigo_Franquia_Visitante: filtroVisitante > 0 ? filtroVisitante : visitante,
            data_Inicio: filtroData === "" ? null : filtroData,
            quantidade_Dias: filtroQtdDias

        }


        await ApostaService.getJogosNBAPorFiltros(filtro)
            .then((result) => {
                const lst = result.dado;
                let filterList = lst.filter(e => { return e !== null });
                console.log("filterList");
                console.log(filterList);

                const distinctDates = [...new Set(filterList.map(item => item.data_Inicio.substring(0, 10)))];
                setLstDataJogosNba(distinctDates);
                filterList.forEach((f, i) => {
                    if (f.aposta !== null) {
                        if (f.aposta.codigo_Franquia_NBA === f.codigo_Franquia_NBA_Mandante) {
                            eval(`setChkMandante${i + 1}(true);`);
                        }
                        else if (f.aposta.codigo_Franquia_NBA === f.codigo_Franquia_NBA_Visitante) {
                            eval(`setChkVisitante${i + 1}(true);`);
                        }
                        eval(`setMargemEscolha${i + 1}(f.aposta.margem)`);
                        eval(`setPick${i + 1}(false)`);
                    }
                    else {
                        eval(`setChkMandante${i + 1}(false);`);
                        eval(`setChkVisitante${i + 1}(false);`);
                        eval(`setPick${i + 1}(false)`);
                        eval(`setMargemEscolha${i + 1}(1)`);
                    }
                })

                setLstJogosNba(filterList);
                setIsLoading(false);
                setRemoveLoading(true);

            })
            .catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                if (errors.response != undefined) {
                    if (errors.response.data.statusHTTP === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response !== undefined && errors.response.data.mensagem !== undefined
                            ? errors.response.data.mensagem : "Não foi possível carregar os dados das apostas! Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                };
            });

    }
    //#region Configuração tabela

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
            padding: "5px"
        },
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));

    const handleVerificarValoresTabela = (valor: any) => {
        if (valor !== undefined && valor !== null) {
            return valor.toFixed(2).replace(".", ",");
        }
        return 0;
    }

    //#endregion

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
        }
    };

    const handleAlterarApostas = async (codigoJogo: number, codigoFranquia: number, margemEscolhida: number, codigoTemporada: number) => {
        setIsLoading(true);
        setRemoveLoading(false);
        if (codigoFranquia === 0 || codigoFranquia === undefined) {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Favor escolher uma franquia!",
                display: "none",
                titulo: "Atenção"
            });

            setRedirecionar("");
            return;
        }

        let aposta: IDetalheAposta = {
            codigo_Jogo_NBA: codigoJogo,
            codigo_Franquia_NBA: codigoFranquia,
            margem: margemEscolhida,
            codigo_Usuario: user.codUsuario,
            codigo_Temporada: codigoTemporada
        }

        if (listaApostasRows.filter(f => f.codigo_Jogo_NBA === codigoJogo).length > 0) {
            let newList = listaApostasRows.filter(f => f.codigo_Jogo_NBA !== codigoJogo);
            newList.push(aposta)
            setListaApostasRows(newList);
            await ApostaService.Create(aposta)
                .then((result) => {
                    // setIsLoading(false);
                    // setRemoveLoading(true);
                    // setShowModalMensagem(true);
                    // setDadosModal({
                    //     acao: true,
                    //     label: "",
                    //     tipo: "success",
                    //     mensagem: "Aposta atualizada com sucesso!",
                    //     display: "none",
                    //     titulo: "Atenção"
                    // });
                    setRedirecionar("");
                })
                .catch((errors) => {
                    setIsLoading(false);
                    setRemoveLoading(true);
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    if (errors.response !== undefined && errors.response.data.mensagem !== undefined) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível atualizar os dados da aposta! Favor entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                });
        }
        else {
            listaApostasRows.push(aposta);
            setListaApostasRows([...listaApostasRows]);
            await ApostaService.Create(aposta)
                .then((result) => {
                    // setIsLoading(false);
                    // setRemoveLoading(true);
                    // setShowModalMensagem(true);
                    // setDadosModal({
                    //     acao: true,
                    //     label: "",
                    //     tipo: "success",
                    //     mensagem: "Aposta salva com sucesso!",
                    //     display: "none",
                    //     titulo: "Atenção"
                    // });
                    setRedirecionar("");
                })
                .catch((errors) => {
                    setIsLoading(false);
                    setRemoveLoading(true);
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    if (errors.response !== undefined && errors.response.data.mensagem !== undefined) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível cadastrar os dados da aposta! Favor entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                });
        }
        handleCarregarJogosNBA(null, null, null, "", quantidadeDias);
    }

    const handleSave = async () => {
        let dados: IDetalheAposta[] = [];

    }

    const handleCancelarAposta = (codigo: number) => {
        setShowModalEvent(true);
        setDadosModalEvent({
            acao: true,
            label: "Cancelar Aposta",
            tipo: "info",
            mensagem: `Deseja cancelar essa aposta?`,
            display: "none",
            titulo: "Atenção",
            evento: "cancelarAposta",
            info: {
                codigo: codigo,
                mensagemAdicional: "",
                style: { color: "red", fontWeight: "bold", wordWrap: "break-word", whiteSpace: "pre-line" }
            }
        });
        setRedirecionar("0");
    }

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
        }
    }

    const seenItems = new Set();

    return (
        <LayoutBaseDePagina
            titulo="Lista de Jogos"
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoApagar={false}
                    mostrarBotaoNovo={false}
                    mostrarBotaoSalvar={false}
                    aoClicarEmSalvar={save}
                    aoClicarEmSalvarEFechar={saveAndClose}
                    aoClicarEmVoltar={() => navigate(-1)}
                />
            }
        >
            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}

            {showModalMensagem && <DialogMensagem dados={dadosModal} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container direction="column" padding={2} spacing={3}>
                        <Grid size={{ xs: 12 }} spacing={2}>
                            {!removeLoading && <Loading />}
                        </Grid>
                        <Grid container size={{ xs: 12 }} spacing={2}>
                            <Grid size={{ xs: 6, sm: 3, md: 3 }} padding={2}>
                                <FormControl fullWidth disabled={isLoading} key={"filtroQtdDias"}>
                                    <InputLabel>Quantidade Dias</InputLabel>
                                    <Select
                                        variant="outlined"
                                        native={false}
                                        value={quantidadeDias}
                                        label="Quantidade Dias"
                                        defaultValue={1}
                                        sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? "10px" : "auto" }}
                                        onChange={e => {
                                            setQuantidadeDias(Number(e.target.value));
                                            handleCarregarJogosNBA(null, null, null, "", Number(e.target.value));
                                        }}
                                    >

                                        <MenuItem key={1} sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? "10px" : "auto" }} value={1}>{1}</MenuItem>
                                        <MenuItem key={2} sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? "10px" : "auto" }} value={2}>{2}</MenuItem>
                                        <MenuItem key={3} sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? "10px" : "auto" }} value={3}>{3}</MenuItem>
                                        <MenuItem key={4} sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? "10px" : "auto" }} value={4}>{4}</MenuItem>
                                        <MenuItem key={5} sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? "10px" : "auto" }} value={5}>{5}</MenuItem>
                                    </Select>
                                </FormControl >
                            </Grid>
                        </Grid>
                        <Grid container size={{ xs: 12 }} spacing={2}>
                            <>
                                <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                    <hr />
                                </Grid>
                                {lstJogosNba.length > 0 ? (lstJogosNba.map((jogo, i) => (
                                    <>

                                        {!seenItems.has(jogo.data_Inicio.substring(0, 10)) &&
                                            <>
                                                < Grid size={12} display={"flex"} justifyContent={"left"} alignSelf={"top"} paddingTop={2}>
                                                    <Typography variant={UtilidadeService.isMobile() ? "body1" : "h6"}>
                                                        DATA DO JOGO: {jogo.data_Inicio.substring(0, 10)}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={12} display={"none"}>
                                                    <>
                                                        {seenItems.add(jogo.data_Inicio.substring(0, 10))}
                                                    </>
                                                </Grid>
                                            </>
                                        }

                                        <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                                            <Card key={jogo.codigo}
                                            >
                                                <CardActionArea>
                                                    <CardContent sx={{ padding: 2, paddingBottom: 1 }} >
                                                        <Grid display={eval(`pick${i + 1}`) === true ? "flex" : "none"} size={{ xs: 12 }} spacing={2}>
                                                            {!removeLoading && <Loading />}
                                                        </Grid>
                                                        <Box width="100%" display="flex" flexDirection="row" alignSelf={"center"}>
                                                            <Grid size={2} display={"flex"} justifyContent={"left"} alignSelf={"top"}>
                                                                <Typography variant="body1" >
                                                                    Nº: {jogo.codigo_NBA}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={9} spacing={1} gap={1} display={"flex"} justifyContent={"center"} alignSelf={"center"}>
                                                                <Typography variant="h6" >
                                                                    <img src={jogo.logo_Franquia_NBA_Mandante === null ? showImagemFranquia : jogo.logo_Franquia_NBA_Mandante} width={UtilidadeService.isMobile() ? 30 : 60} height={UtilidadeService.isMobile() ? 30 : 60} />
                                                                </Typography>
                                                                <Typography variant={"h6"} sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? "11px" : "auto" }}>
                                                                    {jogo.sigla_Franquia_NBA_Mandante.toUpperCase()}  <span style={{ color: "#fbc02d" }}> X </span> {jogo.sigla_Franquia_NBA_Visitante.toUpperCase()}
                                                                </Typography>
                                                                <Typography variant="body2" >
                                                                    <img src={jogo.logo_Franquia_NBA_Visitante === null ? showImagemFranquia : jogo.logo_Franquia_NBA_Visitante} width={UtilidadeService.isMobile() ? 30 : 60} height={UtilidadeService.isMobile() ? 30 : 60} />
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={1} spacing={1} gap={1} display={"flex"} justifyContent={"center"} alignSelf={"center"}>

                                                            </Grid>
                                                        </Box>
                                                        <Grid container size={12}>
                                                            <Box width="100%" display="flex" flexDirection="column">
                                                                <Grid container size={12} paddingBottom={2}>
                                                                    <Grid size={{ xs: 12, sm: 6, md: 5 }} >
                                                                        <Typography variant={"h6"} sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? "10px" : "16px" }} >
                                                                            Data: {jogo.data_Inicio !== null ? jogo.data_Inicio.toString() : ""}
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid size={{ xs: 12, sm: 6, md: 5 }}>
                                                                        <Typography variant={"h6"} sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? "10px" : "16px" }} >
                                                                            Situação: {jogo.iniciado ? "FECHADO" : "ABERTO"}
                                                                        </Typography>
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid container size={12} display={"flex"} justifyContent={"center"}>
                                                                    <Grid size={4} display={"flex"} justifyContent={"center"} alignSelf={"center"}>
                                                                        <Typography variant={"h6"} sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? "10px" : "16px" }}>
                                                                            <FormControl >
                                                                                <FormControlLabel
                                                                                    control={<MuiCheckBox
                                                                                        name="escolhaMandante"
                                                                                        disabled={jogo.iniciado}
                                                                                        checked={eval(`chkMandante${i + 1}`)}
                                                                                        //icon={<img src={jogo.logo_Franquia_NBA_Mandante === null ? showImagemFranquia : jogo.logo_Franquia_NBA_Mandante} width={UtilidadeService.isMobile() ? 30 : 60} height={UtilidadeService.isMobile() ? 30 : 60} />}
                                                                                        onChange={e => {
                                                                                            eval(`setPick${i + 1}(true)`);
                                                                                            eval(`setChkMandante${i + 1}(e.target.checked);`);
                                                                                            eval(`setChkVisitante${i + 1}(false)`);
                                                                                            handleAlterarApostas(jogo.codigo_NBA, jogo.codigo_Franquia_NBA_Mandante, eval(`margemEscolha${i + 1}`), jogo.codigo_Temporada);
                                                                                        }}
                                                                                    />}
                                                                                    sx={{ '& .MuiFormControlLabel-label': { fontSize: UtilidadeService.isMobile() ? 12 : 18 } }}
                                                                                    label={jogo.nome_Franquia_NBA_Mandante}
                                                                                    labelPlacement="start"
                                                                                />
                                                                            </FormControl>
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid size={1} display={"flex"} justifyContent={"center"} alignSelf={"center"}>
                                                                        <Typography variant={"h6"} sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? "10px" : "auto" }} >
                                                                            X
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid size={4} display={"flex"} justifyContent={"center"} alignSelf={"center"}>
                                                                        <Typography variant={"h6"} sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? "10px" : "auto" }}>
                                                                            <FormControl >
                                                                                <FormControlLabel
                                                                                    control={<MuiCheckBox
                                                                                        name="escolhaVisitante"
                                                                                        disabled={jogo.iniciado}
                                                                                        //icon={<img src={jogo.logo_Franquia_NBA_Visitante === null ? showImagemFranquia : jogo.logo_Franquia_NBA_Visitante} width={UtilidadeService.isMobile() ? 30 : 60} height={UtilidadeService.isMobile() ? 30 : 60} />}
                                                                                        checked={eval(`chkVisitante${i + 1}`)}
                                                                                        onChange={e => {
                                                                                            eval(`setPick${i + 1}(true)`);
                                                                                            eval(`setChkVisitante${i + 1}(e.target.checked);`);
                                                                                            eval(`setChkMandante${i + 1}(false)`);
                                                                                            handleAlterarApostas(jogo.codigo_NBA, jogo.codigo_Franquia_NBA_Visitante, eval(`margemEscolha${i + 1}`), jogo.codigo_Temporada);
                                                                                        }}
                                                                                    />}
                                                                                    sx={{ '& .MuiFormControlLabel-label': { fontSize: UtilidadeService.isMobile() ? 12 : 18 } }}
                                                                                    label={jogo.nome_Franquia_NBA_Visitante}
                                                                                    labelPlacement="end"
                                                                                />
                                                                            </FormControl>
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid size={{ xs: 6, sm: 3, md: 3 }} padding={2}>
                                                                        <FormControl fullWidth disabled={isLoading} key={`margem_${jogo.codigo}`}>
                                                                            <InputLabel key={`InputLabel_${jogo.codigo}`} id={`${i}`}>Margem</InputLabel>
                                                                            <Select
                                                                                key={`select_${jogo.codigo}`}
                                                                                variant="outlined"
                                                                                native={false}
                                                                                value={eval(`margemEscolha${i + 1}`)}
                                                                                label="Margem"
                                                                                defaultValue={1}
                                                                                disabled={jogo.iniciado}
                                                                                sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? "10px" : "auto" }}
                                                                                onChange={e => {
                                                                                    eval(`setMargemEscolha${i + 1}(Number(e.target.value))`);
                                                                                    eval(`setPick${i + 1}(true)`);
                                                                                    handleAlterarApostas(jogo.codigo_NBA, eval(`chkVisitante${i + 1}`) === true ? jogo.codigo_Franquia_NBA_Visitante : eval(`chkMandante${i + 1}`) === true ? jogo.codigo_Franquia_NBA_Mandante : 0, Number(e.target.value), jogo.codigo_Temporada)
                                                                                }}
                                                                            >
                                                                                {
                                                                                    enumMargemAposta.map(a => (
                                                                                        <MenuItem
                                                                                            key={a.codigo}
                                                                                            sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? "10px" : "auto" }}
                                                                                            value={a.codigo}>
                                                                                            {a.label}
                                                                                        </MenuItem>))
                                                                                }
                                                                            </Select>
                                                                        </FormControl >
                                                                    </Grid>
                                                                    <Grid size={12}>
                                                                        <hr />
                                                                    </Grid>
                                                                    <Grid container size={12} display={"flex"} justifyContent={"center"} padding={2}>
                                                                        <Grid size={{ xs: 10, sm: 10, md: 10 }} display={"flex"} justifyContent={"center"}>
                                                                            <Typography variant={UtilidadeService.isMobile() ? "body1" : "h6"} style={{ color: "#fbc02d" }} >
                                                                                {jogo.aposta === null ? "SEM APOSTA" : jogo.aposta.codigo_Franquia_NBA === jogo.codigo_Franquia_NBA_Visitante
                                                                                    ? "APOSTADO: " + jogo.nome_Franquia_NBA_Visitante.toUpperCase() + " / " + enumMargemAposta.find(f => f.codigo === eval(`margemEscolha${i + 1}`))?.label
                                                                                    : "APOSTADO: " + jogo.nome_Franquia_NBA_Mandante.toUpperCase() + "  /  " + enumMargemAposta.find(f => f.codigo === eval(`margemEscolha${i + 1}`))?.label}
                                                                            </Typography>
                                                                        </Grid>
                                                                        <Grid size={{ xs: 2, sm: 2, md: 2 }} display={"flex"} justifyContent={"center"}>
                                                                            <Typography variant={UtilidadeService.isMobile() ? "body1" : "h6"} style={{ color: "#fbc02d" }} >
                                                                                {
                                                                                    jogo.aposta !== null && (
                                                                                        <IconButton size="small" onClick={()=> handleCancelarAposta(jogo.aposta.codigo)}>
                                                                                            <Tooltip title="Cancelar"><Cancel sx={{ color: jogo.aposta.situacao === 1 ? "#E91309" : "auto" }} /></Tooltip>
                                                                                        </IconButton>
                                                                                    )
                                                                                }
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </Box>
                                                        </Grid>
                                                    </CardContent>
                                                </CardActionArea>
                                            </Card>
                                        </Grid>
                                    </>
                                )))
                                    : <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                        <Typography variant="h6">Nenhum jogo cadastrado</Typography>
                                        <hr />
                                    </Grid>
                                }
                            </>
                        </Grid>

                    </Grid>
                </Box>
            </VForm>
        </LayoutBaseDePagina >
    );
}